import Immutable from 'seamless-immutable';
import * as actionTypes from './actionTypes';

const initialState = Immutable({
  params: {},
  connections: {
    byId: {},
  },
  notices: {
    byId: {}
  },
  readPosts: {
    byId: {}
  },
  actionsloading: false
});

export function dashboardReducer(state = initialState, action) {
  // console.log('in dashboard reduecer....', action)
  switch (action.type) {
    case actionTypes.GET_READ_POSTS:
    case actionTypes.GET_CONNECTIONS:
    case actionTypes.GET_NOTICES:
      return {
        ...state,
        actionsloading: true
      }
    case actionTypes.GET_READ_POSTS_SUCCESS:
      return {
        ...state,
        readPosts: {
          ...state.readPosts,
          byId: action.payload.byId || {},
        },
        actionsloading: false
      }
    case actionTypes.GET_CONNECTIONS_SUCCESS:
      return {
        ...state,
        connections: {
          ...state.connections,
          byId: action.payload.byId || {},
        },
        actionsloading: false
      }
    case actionTypes.GET_NOTICES_SUCCESS:
      return {
        ...state,
        notices: {
          ...state.notices,
          byId: action.payload.byId || {},
        },
        actionsloading: false
      }
    default:
      return state;
  }
}